<template>
    <GuestLayout>
        <div class="space-y-16 pt-8 pb-16 md:pt-12 md:pb-24">
            <!-- Title -->
            <div class="mx-auto max-w-7xl px-6 lg:px-8">
                <div class="mx-auto max-w-2xl lg:mx-0">
                    <p
                        class="text-base font-semibold leading-7 text-bluewood-800"
                    >
                        Latest work from home jobs
                    </p>
                    <h1
                        class="mt-2 text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl"
                    >
                        {{ pageTitle }}
                    </h1>
                    <p class="mt-6 text-lg leading-8 text-gray-600">
                        {{ pageDescription }}
                    </p>
                </div>
            </div>
            <ListingsContent />
        </div>
    </GuestLayout>
</template>

<script setup>
import GuestLayout from "@/Layouts/GuestLayout.vue";
import ListingsContent from "@/Components/Guest/Listings/ListingsContent.vue";
import useListings from "@/Components/Guest/Listings/useListings.js";

const props = defineProps({
    tags: Object,
    listings: Object,
    categories: Object,
    experiences: Object,
    commitments: Object,
    remoteStatuses: Object,
    benefits: Object,
    salaryRanges: Object,
    filters: Object,
    pageTitle: String,
    pageDescription: String,
    currentRoute: String,
});

useListings(props);
</script>
